'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/productListCarouselDesktop'));
    processInclude(require('./components/categoryListCarouselDesktop'));
    processInclude(require('./components/bannerCarousel'));
});
